import { toastr } from 'react-redux-toastr';
import jsonWebTokenService from 'jsonwebtoken';
import axios from 'axios';
import { URL } from '../../assets/js/constants';

export function login(values) {
    return async dispatch => {
        try {
            // 1. Envia os dados para o endpoint de login
            const loginResp = await axios.post(`${URL}/login`, values);
            const token = loginResp.headers?.authorization;

            if (!token) {
                const titulo = 'Falha no login';
                const msg = 'Token não encontrado no header.';
                const erro = { titulo, msg };
                dispatch({ type: 'USER_LOGIN_ERROR', payload: erro });
                return;
            }

            // 2. Decodifica o token para obter o E-mail do usuário
            //const emailUser = jsonWebTokenService.decode(token.substring(7)).sub;
            const { email } = values;

            // 3. Busca os dados do usuário
            const userResp = await axios.get(`${URL}/usuarios/login/${email}`, {
                headers: { Authorization: token }
            });

            const objUser = userResp.data;
            const objUnion = { ...objUser, token };
            const { perfis } = objUser;

            const possuiPerfilProfissional = perfis.some(p =>
                p === 'GERENTE_NEGOCIO' ||
                p === 'ASSISTENTE_NEGOCIO'
            );

            const possuiPerfilAdminApp = perfis.some(p =>
                p === 'ADMIN_APP' ||
                p === 'ASSISTENTE_SENIOR_APP' ||
                p === 'ASSISTENTE_JUNIOR_APP' ||
                p === 'DESENVOLVEDOR_APP'                
            );

            if (possuiPerfilProfissional) {
                const negocio = objUser.funcionarios[0].idNegocio;
                dispatch({
                    type: 'NEGOCIO_USUARIO_SETED',
                    payload: negocio
                });
            }

            if (possuiPerfilProfissional || possuiPerfilAdminApp) {
                dispatch({
                    type: 'USER_LOGIN_FETCHED',
                    payload: objUnion
                });

                window.location.href = '/dashboard';
            } else {
                const erro = {
                    titulo: 'Ops!',
                    msg: 'A sua Loja não está cadastrada no Passarela 44 ou não está ativa. Entre em contato com um dos nossos consultores.'
                };

                dispatch({
                    type: 'USER_LOGIN_ERROR',
                    payload: erro
                });
            }

        } catch (e) {
            const titulo = e.response?.data?.error || 'Erro de autenticação';
            const msg = e.response?.data?.message || 'Erro inesperado durante o login.';
            const erro = { titulo, msg };
            dispatch({ type: 'USER_LOGIN_ERROR', payload: erro });
        }
    };
}

export function submit(values) {
    return dispatch => {
        axios.post(`${URL}/login`, values)
            .then(resp => {
                const token = resp.headers.authorization;

                if (!token) throw new Error('Token não encontrado no header');
                
                const objToken = { token: token };
                const emailUser = jsonWebTokenService.decode(token.substring(7)).sub;
                axios.get(`${URL}/funcionarios/dados-login/${emailUser}`, {
                    headers: { Authorization: token }
                })
                    .then(resp => {
                        const objUser = resp.data;
                        const objUnion = { ...objUser, ...objToken };
                        dispatch([
                            { type: 'USER_LOGIN_FETCHED', payload: objUnion },
                        ])
                    })
                    .then(_ => dispatch(window.location.href = '/dashboard'))
                    .catch(e => {
                        if (e.response) {
                            toastr.error(e.response.data.error, e.response.data.message)
                        }
                    })
            })
            .catch(e => {
                const titulo = e.response?.data?.error || 'Erro';
                const msg = e.response?.data?.message || 'Erro inesperado';
                toastr.error(titulo, msg);
            })
    }
}

export function logout() {
    return { type: 'USER_LOGOUT_COMPLETED', payload: false }
}

export function validateToken(token) {
    return dispatch => {
        if (token) {
            axios.post(`${URL}/auth/refresh_token`, {}, {
                headers: { Authorization: token }
            })
                .then(resp => {
                    dispatch([
                        { type: 'TOKEN_VALIDATED', payload: resp.headers.authorization }
                    ])
                })
                .catch(e => {
                    dispatch({ type: 'TOKEN_VALIDATED', payload: false })
                })
        } else {
            dispatch({ type: 'TOKEN_VALIDATED', payload: false })
        }
    }
}